<div class="swiper-container" #swiperEl>
  <div class="swiper-wrapper">
    <div class="swiper-slide" *ngFor="let img of carouselImgs">
      <img [src]="img" [alt]="'Slide ' + (carouselImgs.indexOf(img) + 1)" />
    </div>
  </div>
</div>
